import React from 'react';
import { Link } from 'react-router';
import styles from './logo.module.scss';

const Logo = () => {
  return (
    <div className={styles.logo}>
      <Link to="/" className={styles.image}>
        <img
          className="logo-header d-inline-block align-top img-fluid"
          src="https://static.schola.com/ScholaR.webp"
          alt="Schola® Logo"
          width="152"
          height="54"
        />
      </Link>
    </div>
  );
};

export default Logo;
